module.exports = __webpack_public_path__ + "static/media/benefits-left-thumbnail.2aaf2a22.gif";